import type { FunctionComponent } from "preact";
import { useTranslator } from "../../hooks/i18n.ts";
import { useStore } from "@nanostores/preact";
import { loadFFmpegTask } from "../../store/ffmpeg.ts";
import { TaskStatus } from "../../store/task/task.ts";

export type FFmpegLoaderProps = {
    children: unknown,
};

export const FFmpegLoader: FunctionComponent<FFmpegLoaderProps> = (props) => {
    const task = useStore(loadFFmpegTask.$store, { keys: ["status", "current", "total", "info"] });
    const t = useTranslator();
    switch (task.status) {
        case TaskStatus.Pending:
            return (
                <button
                    type="button"
                    onClick={() => {
                        loadFFmpegTask.start();
                    }}
                >
                    {t({ zh: "加载组件", en: "Load Components" })}
                </button>
            );
        case TaskStatus.Running:
            return (
                <>
                    <i>
                        {t({ zh: "正在加载组件", en: "Loading components" })}
                        {task.info ? ` - ${task.info}` : ""}
                    </i>
                    <small style={{ display: "block", marginTop: "0.25rem" }}>
                        {t({ zh: "第一次加载比较缓慢，耐心等待几十秒", en: "First-time load may be slow. Please wait for tens of seconds." })}
                    </small>
                    {task.total > 0 ? <progress value={task.current} max={task.total} /> : <progress />}
                </>
            );
        case TaskStatus.Finished:
            return props.children;
        case TaskStatus.Error:
            return (
                <mark>
                    {t({ zh: "加载组件失败: ", en: "Failed to load components: " }) +
                        (task.info || "") +
                        " (Error Code: " + task.errorCode.toString() + ")"}
                </mark>
            );
    }
};
export default FFmpegLoader
